<template>
  <v-ons-page>
    <v-ons-toolbar class="home-toolbar" style="color: black;">
      <div class="left">
        <v-ons-button modifier="quiet" style="margin: 6px 0" @click="goBack()">＜戻る</v-ons-button>
      </div>
      <div class="center" style="text-align: center;">{{ msg }}</div>
      <div class="right"></div>
    </v-ons-toolbar>

    <v-ons-modal :visible="spinning">
      <div class="header">
        <img src="../../assets/lasmeru-logo-bold.png" width="240" height="80">
      </div>
      <p style="text-align: center">
        ver {{this.appVersion}}<br><br>
        Loading...<v-ons-icon icon="fa-spinner" spin></v-ons-icon>
      </p>
    </v-ons-modal>

    <v-ons-list>
      <v-ons-list-item>
        <div class="center">
          <v-ons-button modifier="outline" @click="goCustomerPortal()">購入履歴ページへ</v-ons-button>
        </div>
        <div class="right">
          <v-ons-button modifier="quiet" @click="dialogTokushoho = true">
            <span style="font-size: 0.7em;">特定商取引法に基づく表示</span>
          </v-ons-button>
        </div>
      </v-ons-list-item>

      <div v-if="readyToShow">
        <!-- <v-ons-list-header>購入可能なライセンス</v-ons-list-header>
        <div v-for="(product, index) in products" :key="index">
          <div v-if="(lic.role === 'free') || ((lic.role === 'basic') && !isValidDue) || ((lic.role === 'premium') && (product.productData.role === 'premium') && !isValidDue)">
            <v-ons-list-item modifier="nodivider">
              <div class="left"><img :src="product.productData.images" width="120" height="120"></div>
              <div class="center">
                <span class="list-item__title" style="font-size: 0.7em;">
                  {{product.productData.name}}
                </span>
                <span class="list-item__subtitle" style="font-size: 0.7em;">
                  {{product.productData.description}}
                </span>
              </div>
            </v-ons-list-item>
            <v-ons-list-item modifier="nodivider">
              <div class="left">プランを選択</div>
              <div class="center">
                <v-ons-select v-model="selectedPrice">
                  <option v-for="(price, index) in product.prices" :value="price.priceId" :key="index">
                    <span style="text-align: right;">
                      {{price.priceData.interval_count}}{{price.priceData.interval | convInterval(price.priceData.currency)}}　{{ price.priceData.unit_amount }}円
                    </span>
                  </option>
                </v-ons-select>
              </div>
            </v-ons-list-item>
          </div>
        </div> -->

        <div>
          <v-ons-list-item modifier="nodivider">
            <table border="1" width="100%" cellspacing="0" cellpadding="5" bordercolor="#333333">
              <tr>
                <!-- <th width="30%" align="center">無料プラン</th> -->
                <th width="30%" align="center"><img src="../../assets/BasicPass.png" width="120" height="120"></th>
                <th width="30%" align="center"><img src="../../assets/Premium.png" width="120" height="120"></th>
              </tr>
              <tr style="font-size: 0.8em;">
                <!-- <td valign="top" width="30%"><span class="naiyou">アカウント登録後にはデフォルトで無料プランとなります。まずは基本機能を試してみましょう。期間終了までに他のプランへの乗り換えをご検討ください。</span></td> -->
                <td valign="top" width="30%"><span class="naiyou">1年ごとに更新するプランです。メッセージ数がそれほど多く必要ではない方に向いています。送信日指定はプランの有効期間内までしか指定できません。プランの更新を行わずに有効期間切れになった場合には、お預かりしているメッセージが送信されませんので注意が必要です。</span></td>
                <td valign="top" width="30%"><span class="naiyou">1年ごとに更新するプランですが、有効期限切れになった場合でもお預かりしているメッセージのリマインダー、送信日指定メッセージは継続動作します。送信日指定にも未来の日付に制限はありません。動画ファイルをメッセージに添付することも可能です。有効期限切れの場合には、新規メッセージの追加と編集が行えなくなりますが、実質的に１年間払い切りでその後もサービスが続く限りメッセージのお預かりを行うプランです。</span></td>
              </tr>
              <tr style="font-size: 0.8em;">
                <!-- <td valign="top" width="30%"><span class="koumoku">期間：</span><span class="naiyou">90日間</span></td> -->
                <td valign="top" width="30%"><span class="koumoku">期間：</span><span class="naiyou">１年間</span></td>
                <td valign="top" width="30%"><span class="koumoku">期間：</span><span class="naiyou">１年間</span></td>
              </tr>
              <tr style="font-size: 0.8em;">
                <!-- <td valign="top" width="30%"><span class="koumoku">メッセージ数：</span><br>
                                             <span class="naiyou">トリガー型 x 2</span><br>
                                             <span class="naiyou">送信日指定 x 2</span></td> -->
                <td valign="top" width="30%"><span class="koumoku">メッセージ数：</span><br>
                                             <span class="naiyou">トリガー型 x 10</span><br>
                                             <span class="naiyou">送信日指定 x 10</span></td>
                <td valign="top" width="30%"><span class="koumoku">メッセージ数：</span><br>
                                             <span class="naiyou">トリガー型 x 30</span><br>
                                             <span class="naiyou">送信日指定 x 30</span></td>
              </tr>
              <tr style="font-size: 0.8em;">
                <!-- <td valign="top" width="30%"><span class="koumoku">動画数：</span><span class="naiyou">0</span></td> -->
                <td valign="top" width="30%"><span class="koumoku">動画数：</span><span class="naiyou">0</span></td>
                <td valign="top" width="30%"><span class="koumoku">動画数：</span><span class="naiyou">3</span><br><span class="naiyou">(512MB以下 x 3)</span></td>
              </tr>
              <tr style="font-size: 0.8em;">
                <!-- <td valign="top" width="30%"><span class="koumoku">送信日指定範囲：</span><span class="naiyou">登録日から90日</span></td> -->
                <td valign="top" width="30%"><span class="koumoku">送信日指定範囲：</span><span class="naiyou">購入日から１年</span></td>
                <td valign="top" width="30%"><span class="koumoku">送信日指定範囲：</span><span class="naiyou">無制限</span><br><span class="naiyou">20年先でも設定可</span></td>
              </tr>
              <tr style="font-size: 0.8em;">
                <!-- <td valign="top" width="30%"><span class="koumoku">有効期間終了後のトリガー型メッセージ：</span><br><span class="naiyou">リマインダー停止<br>メッセージは送られません。</span></td> -->
                <td valign="top" width="30%"><span class="koumoku">有効期間終了後のトリガー型メッセージ：</span><br><span class="naiyou">リマインダー停止<br>メッセージは送られません。</span></td>
                <td valign="top" width="30%"><span class="koumoku">有効期間終了後のトリガー型メッセージ：</span><br><span class="naiyou">リマインダー継続<br>有効期間後も動作します。</span></td>
              </tr>
              <tr style="font-size: 0.8em;">
                <!-- <td valign="top" width="30%"><span class="koumoku">価格：</span><span>0円</span></td> -->
                <td valign="top" width="30%"><span class="koumoku">価格：</span><span>1980円</span></td>
                <td valign="top" width="30%"><span class="koumoku">価格：</span><span>5980円</span></td>
              </tr>
             　<tr style="font-size: 0.8em;">
                <!-- <td valign="top" width="30%" align="center"></td> -->
                <td valign="top" width="30%" align="center">
                  <div v-if="(lic.role === 'free') || ((lic.role === 'basic') && !isValidDue)">
                    <v-ons-button @click="selectedPrice = 'basic'">選択</v-ons-button>
                  </div>
                  <span v-if="selectedPrice === 'basic'">
                    <v-ons-button modifier="quiet"><v-ons-icon icon="fa-check"></v-ons-icon></v-ons-button>
                  </span>
                </td>
                <td valign="top" width="30%" align="center">
                  <div v-if="(lic.role === 'free') || ((lic.role === 'basic') && !isValidDue) || ((lic.role === 'premium') && !isValidDue)">
                    <v-ons-button @click="selectedPrice = 'premium'">選択</v-ons-button>
                  </div>
                  <span v-if="selectedPrice === 'premium'">
                    <v-ons-button modifier="quiet"><v-ons-icon icon="fa-check"></v-ons-icon></v-ons-button>
                  </span>
                </td>
              </tr>
            </table>
          </v-ons-list-item>
        </div>

        <div v-if="((lic.role === 'basic') && isValidDue)">
          <v-ons-list-item modifier="nodivider">
            <div class="center">
              ベーシックからプレミアムへアップグレードしませんか？<br>
              アップブレードすることで、メッセージ数の増加など多くのメリットがあります。
            </div>
          </v-ons-list-item>
          <v-ons-list-item modifier="nodivider">
            <div class="center">
              <v-ons-button @click="upgradeToPremium()" modifier="large">プレミアムへアップグレードする</v-ons-button>
            </div>
          </v-ons-list-item>
        </div>

        <v-ons-list-item modifier="nodivider">
          <div class="center">
            <v-ons-button :disabled="!selectedPrice" @click="subscribe" modifier="large">購入する</v-ons-button>
          </div>
        </v-ons-list-item>
      </div>
    </v-ons-list>

    <v-ons-dialog :visible.sync="dialogTokushoho">
      <div class="dialogview2">
        <v-ons-button class="closebutton" modifier="quiet" @click="dialogTokushoho = false"><v-ons-icon icon="fa-window-close"></v-ons-icon></v-ons-button>
        <v-ons-card>
          <div class="content">
            <v-ons-list-title>特定商取引法に基づく表示</v-ons-list-title>
            <v-ons-list>
              <v-ons-list-header>販売社名</v-ons-list-header>
              <v-ons-list-item>
                <div class="center">
                  <span style="color: gray; font-size: 0.9em;">合同会社Miley's</span>
                </div>
              </v-ons-list-item>
              <v-ons-list-header>運営統括責任者</v-ons-list-header>
              <v-ons-list-item>
                <div class="center">
                  <span style="color: gray; font-size: 0.9em;">合田　照彦</span>
                </div>
              </v-ons-list-item>
              <v-ons-list-header>所在地</v-ons-list-header>
              <v-ons-list-item>
                <div class="center">
                  <span style="color: gray; font-size: 0.9em;">京都府京田辺市三山木直田28−25</span>
                </div>
              </v-ons-list-item>
              <v-ons-list-header>電話番号</v-ons-list-header>
              <v-ons-list-item>
                <div class="center">
                  <span style="color: gray; font-size: 0.9em;">0774-27-6878</span>
                </div>
              </v-ons-list-item>
              <v-ons-list-header>メールアドレス</v-ons-list-header>
              <v-ons-list-item>
                <div class="center">
                  <span style="color: gray; font-size: 0.9em;">support@mileys.co.jp</span>
                </div>
              </v-ons-list-item>
              <v-ons-list-header>商品代金以外の必要金額</v-ons-list-header>
              <v-ons-list-item>
                <div class="center">
                  <span style="color: gray; font-size: 0.9em;">なし</span>
                </div>
              </v-ons-list-item>
              <v-ons-list-header>支払い方法</v-ons-list-header>
              <v-ons-list-item>
                <div class="center">
                  <span style="color: gray; font-size: 0.9em;">クレジットカード</span>
                </div>
              </v-ons-list-item>
              <v-ons-list-header>支払い時期</v-ons-list-header>
              <v-ons-list-item>
                <div class="center">
                  <span style="color: gray; font-size: 0.9em;">各カード会社の引き落とし日</span>
                </div>
              </v-ons-list-item>
              <v-ons-list-header>返品・交換の方法</v-ons-list-header>
              <v-ons-list-item>
                <div class="center">
                  <span style="color: gray; font-size: 0.9em;">サービス利用権の販売となりますので、返品、キャンセルには対応しておりません。</span>
                </div>
              </v-ons-list-item>
            </v-ons-list>

          </div>
        </v-ons-card>
      </div>
    </v-ons-dialog>

  </v-ons-page>
</template>

<script>
import firebase from 'firebase'
// import * as firebaseui from 'firebaseui'
// import 'firebaseui/dist/firebaseui.css'
import common from '../../util/common'
import comLic from '../../util/com_license'
import {loadStripe} from '@stripe/stripe-js'

// Replace with your publishable key
// https://dashboard.stripe.com/apikeys
// テスト環境
// const STRIPE_PUBLISHABLE_KEY = 'pk_test_51H7KznJsVaTOJ5TUbAtWFF9RyVMc7K8FVJlleQBjAYcZcRNxqHR5v7GxFGmRjIqMFVjJiuYYEt7AxPmPvTH82JMI00RtEiKsgf'
// 本番環境
const STRIPE_PUBLISHABLE_KEY = 'pk_live_51H7KznJsVaTOJ5TUL8oCflYHKxsRl5JQAS4jS03hDnXQb1slhGEfCPBA1kXACTS5vX848TY8eoaaftG9bemZLU5O0052hPZ2bl'

export default {
  name: 'PurchaseLicense',
  mixins: [common, comLic],
  data () {
    return {
      msg: 'ライセンス購入',
      stripe: '',
      products: [],
      purchased: [],
      selectedProduct: null,
      selectedPrice: null,
      watchPurchased: '',
      watchCheckOut: '',
      readyToShow: false,
      spinning: false,
      dialogTokushoho: false
    }
  },

  async created () {
    if (this.$route.params) {
      if (this.$route.params.from === 'AccountRoot') {
        await this.getProducs()
      }
    } else {
      this.$router.push({path: '/'})
    }
  },

  async mounted () {
    this.isValidDue = await this.checkLicenseDue()
    this.stripe = await loadStripe(STRIPE_PUBLISHABLE_KEY)
  },

  destroyed () {
  },

  beforeDestroy () {
    // this.watchPurchased()
    // this.watchCheckOut()
  },

  computed: {
  },

  watch: {
  },

  methods: {
    // Billing portal handler
    goCustomerPortal: async function () {
      // Call billing portal function
      this.spinning = true
      const functionRef = firebase
        .app()
        .functions('asia-northeast1')
        .httpsCallable('ext-firestore-stripe-subscriptions-createPortalLink')
      const { data } = await functionRef({ returnUrl: window.location.origin })
      this.spinning = false
      // window.open(data.url)
      window.location.assign(data.url)
    },

    getProducs () {
      const self = this
      const productsRef = firebase.firestore().collection('products')
      const customersRef = firebase.firestore().collection('customers')

      console.log('getProduct')
      // Productを取得
      productsRef.where('active', '==', true).get()
        .then(function (querySnapshot) {
          querySnapshot.forEach(async function (doc) {
            const productId = doc.id
            const productData = doc.data()
            // console.log('productId: ', productId)
            const priceSnap = await productsRef.doc(productId).collection('prices').orderBy('unit_amount').get()

            // Priceを取得
            let prices = []
            for (let i = 0; i < priceSnap.size; i++) {
              const priceId = priceSnap.docs[i].id
              const priceData = priceSnap.docs[i].data()
              if (priceData.active) {
                prices.push({priceId: priceId, priceData: priceData})
                // console.log('priceId: ', priceId)
              }
            }
            self.products.push({productId: productId, productData: productData, prices: prices})
            self.readyToShow = true
          })
        })
        .catch((error) => {
          console.log('browser back is pressed: ', error)
        })
      // 購入済みプロダクト情報を取得
      this.watchPurchased = customersRef.doc(this.user.userId).collection('subscriptions')
        .where('status', '==', 'active').onSnapshot(async (snapshot) => {
          if (snapshot.empty) {
            return
          }
          for (let i = 0; i < snapshot.size; i++) {
            let item = snapshot.docs[i].data()
            self.purchased.push(item)
            console.log('purchased: ', item)
          }
        })
    },

    // Checkout handler
    subscribe: async function () {
      const customersRef = firebase.firestore().collection('customers')
      let priceId = ''
      for (let i = 0; i < this.products.length; i++) {
        if (this.selectedPrice === this.products[i].productData.role) {
          priceId = this.products[i].prices[0].priceId
        }
      }

      this.spinning = true
      const docRef = await customersRef.doc(this.user.userId)
        .collection('checkout_sessions').add({
          price: priceId, // priceId
          tax_rates: ['txr_1HDt5CJsVaTOJ5TUUMhBYypi'], // 消費税
          success_url: window.location.origin,
          cancel_url: window.location.origin
        })
      // Wait for the CheckoutSession to get attached by the extension
      this.watchCheckOut = docRef.onSnapshot((snap) => {
        const { sessionId } = snap.data()
        if (sessionId) {
          // We have a session, let's redirect to Checkout
          // Init Stripe
          // const stripe = Stripe(STRIPE_PUBLISHABLE_KEY)
          // console.log('stripe', stripe)
          this.stripe.redirectToCheckout({ sessionId })
        }
      })
    },

    upgradeToPremium () {
      const self = this

      this.$options.buttonLabels = ['キャンセル', '購入']
      this.$ons.notification.confirm('プレミアムへのアップグレード<br>ベーシック加入期間を日割計算で<br>差し引いた金額で決済されます。', this.$options)
        .then(response => {
          if (response > 0) {
            self.upgradeToPremiumExe()
          }
        })
    },

    upgradeToPremiumExe: async function () {
      const self = this

      this.spinning = true
      const customersRef = firebase.firestore().collection('customers').doc(this.account.uid)
      // 購入済みプロダクト情報を取得
      let subs = await customersRef.collection('subscriptions')
        .where('status', '==', 'active').where('role', '==', 'basic').get()
        .then((snapshot) => {
          if (snapshot.empty) {
            return null
          }
          let item = snapshot.docs[0].id
          console.log('item== ', item)
          return item
        })

      if (subs === null) {
        return
      }
      console.log('subs::::: ', subs)
      const onCall = firebase.app().functions('asia-northeast1').httpsCallable('upgradePlanOnCall')
      const data = {
        // userId: this.user.userId,
        subsId: subs
      }

      onCall(data)
      .then((result) => {
        self.spinning = false
        console.log('upgradePlanOnCall successed: ', result)
        self.$ons.notification.alert('アップグレードしました！')
        self.moveTab('DefaultComponent', 'back')
      })
      .catch((error) => {
        self.spinning = false
        self.$ons.notification.alert('ERROR: アップグレード失敗！', error)
        console.log('Error upgradePlanOnCall: ', error)
      })
    },

    // Get custom claim role helper
    getCustomClaimRole: async function () {
      await firebase.auth().currentUser.getIdToken(true)
      const decodedToken = await firebase.auth().currentUser.getIdTokenResult()
      return decodedToken.claims.stripeRole
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@import "../../../src/assets/css/miley.css";
.koumoku {
  font-size: 0.7em;
  color: gray;
}
.naiyou {
  font-size: 0.8em;
  color: darkgray;
}
</style>



// WEBPACK FOOTER //
// src/components/AccountChildren/PurchaseLicense.vue